import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos de adultos mayores. Nunca más el domingo de pánico.',
  name: 'Sofía M.',
  role: 'Profesora de Educación Física',
  location: 'Buenos Aires',
  initial: 'S',
  color: 'bg-blue-500'
}, {
  quote: 'Las clases con progresión real por nivel cambiaron todo. Mis alumnos mayores mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
  name: 'Carolina R.',
  role: 'Profe en Centro de Día',
  location: 'Rosario',
  initial: 'C',
  color: 'bg-green-500'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo de mayores de 65.',
  name: 'Valentina F.',
  role: 'Kinesióloga y Entrenadora',
  location: 'Córdoba',
  initial: 'V',
  color: 'bg-purple-500'
}];
export function MiniTestimonials() {
  return <section className="bg-navy-50 py-6 md:py-12 px-4" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-150">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-navy-100 flex flex-col justify-between" data-id="element-151">
              <div className="flex gap-1 mb-4" data-id="element-152">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} className="text-gold fill-gold" data-id="element-153" />)}
              </div>
              <p className="text-navy-700 italic mb-6 flex-grow" data-id="element-154">"{t.quote}"</p>
              <div className="flex items-center gap-3" data-id="element-155">
                <div className={`w-10 h-10 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-lg`} data-id="element-156">
                  {t.initial}
                </div>
                <div data-id="element-157">
                  <p className="font-bold text-navy-900 text-sm" data-id="element-158">{t.name}</p>
                  <p className="text-xs text-navy-500" data-id="element-159">
                    {t.role} · {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}